import React from "react";

import { Box, Chip, Grid, Typography, makeStyles } from "@material-ui/core";

import { getAreaAvatarColor } from "@ds-developer/frontend";

import { ViewDistrictsProps } from "../types";
import AreaAvatar from "../../Area/components/AreaAvatar";

const useStyles = makeStyles(theme => ({
  summary: {
    marginRight: theme.spacing(2),
    "& span": {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  avatarWrapper: {
    display: "flex",
    alignItems: "center",
    marginBottom: 0,
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
    },
  },
  districtChip: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  chipContainer: {
    marginTop: theme.spacing(2),
  },
}));

const ViewDistricts: React.FC<ViewDistrictsProps> = ({
  areaName,
  areaShortCode,
  districts = [],
  totalDistricts = 0,
}) => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item container md={2} xs={12} alignItems="center">
        <Box className={classes.avatarWrapper}>
          {areaName && areaShortCode && (
            <AreaAvatar
              initials={areaShortCode}
              label={areaName}
              color={getAreaAvatarColor(areaName)}
            />
          )}
        </Box>
      </Grid>
      <Grid item container md={10} xs={12} alignItems="center">
        <Typography
          className={classes.summary}
          color="textSecondary"
          data-test="district-coverage-text"
        >
          <span>
            {districts.length} of {totalDistricts}
          </span>{" "}
          districts of {areaShortCode} postcode covered
        </Typography>
        <div className={classes.chipContainer}>
          {districts.map(district => (
            <Chip
              label={`${district.postcode}...`}
              key={district.id}
              className={classes.districtChip}
            />
          ))}
        </div>
      </Grid>
    </Grid>
  );
};

export default ViewDistricts;
